// Copyright (c) 2023. Engie-Electrabel. All rights reserved.
//
// Engie-Electrabel n.v./s.a., Simon Bolivarlaan 34 Boulevard Simón Bolivar, BTW BE 0403.107.701 - 1000 Brussel/Bruxelles, Belgium.
//
// Proprietary Notice:
// This software is the confidential and proprietary information of Engie-Electrabel s.a./n.v. and/or its licensors.
// You shall not disclose this Confidential Information to any third parties and any use thereof shall be subject to the terms and conditions of use, as agreed upon with Engie-Electrabel in writing.
//

import Clipboard from 'clipboard'
import { ElMessage } from 'element-plus'
import type { DirectiveBinding, App } from '@vue/runtime-core'

export default function install (app: App): void {
  function handle (el: any, arg: DirectiveBinding['modifiers'], value: string) {
    if (!el._clipboard) {
      const _clipboard = new Clipboard(el)
      _clipboard.on('success', () => {
        ElMessage.success({ message: 'Copied to clipboard' })
      })
      _clipboard.on('error', () => {
        ElMessage.error({ message: 'Unexpected error' })
      })
      el._clipboard = _clipboard
    }
    (el._clipboard as any).text = () => value
    ;(el._clipboard as any).action = () => arg.cut ? 'cut' : 'copy'
  }

  app.directive('clipboard', {
    beforeMount (el, binding) {
      handle(el, binding.modifiers, binding.value)
    },
    updated (el, binding) {
      handle(el, binding.modifiers, binding.value)
    },
    unmounted (el) {
      el._clipboard.destroy()
      delete el._clipboard
    }
  })
}
